import React, { Component } from "react";
import COLORS from "scss/colors.module.scss";
import { MdArrowDropDown, MdHistory } from "react-icons/md";

import { MdInfo, MdContentCopy, MdEdit, MdDelete } from "react-icons/md";
import { FaLock } from "react-icons/fa";
import { ClickAwayListener, Menu, MenuItem, CircularProgress} from "@material-ui/core";
import { observer } from "mobx-react";
import styled from "styled-components";
import { StyledTooltip } from "../common/utils/StyledTooltip";
import { makeStyles } from "@material-ui/core/styles";
import autoBind from "auto-bind";
import DuplicateSheet from "./DuplicateSheet";
import DuplicateSheetPacksMenu from "./DuplicateSheetPacksMenu";
import DuplicateSheetOptions from "./DuplicateSheetOptions";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
  arrow: {
    color: theme.palette.common.black,
  },
}));

function CustomTooltip(props) {
  const classes = useStyles();
  return (
    <StyledTooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      {...props}
    />
  );
}

class TabName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overflow: false,
      isEditing: false,
      isSaving: false,
      isOptionsOpened: false,
      duplicateSheetPopupOpen: false,
      duplicateOptionsPopupOpen: false,
    };
    this.isSheetRenamed = false;
    autoBind(this);
  }

  addOverFlowToSheet() {
    if (this.tabRef != null) {
      let elementWidth = getComputedStyle(this.tabRef, null).getPropertyValue(
        "width"
      );
      elementWidth = parseInt(
        elementWidth.substring(0, elementWidth.length - 2)
      );
      let isOverFlowed = false;
      if (elementWidth >= 150) {
        isOverFlowed = true;
      }
      if (isOverFlowed !== this.state.overflow) {
        this.setState({ overflow: isOverFlowed });
      }
    }
  }

  componentDidMount() {
    this.addOverFlowToSheet();
  }

  componentDidUpdate() {
    this.addOverFlowToSheet();
    if (
      this.isSheetRenamed === false &&
      this.props.isSelected &&
      this.props.store.lastCreatedSheetId === "" &&
      this.props.store.isNewlyCreatedSheet === true
    ) {
      const addColumnHeaderElement = document.querySelector(
        `#${this.props.store.appStore?.containerStore?.currentViewStore?.gridId} .addColumnHeader`
      );
      if (addColumnHeaderElement) {
        addColumnHeaderElement.click();
        this.props.store.isNewlyCreatedSheet = false;
      }
    }
  }

  getListItem(icon, name, callback) {
    return (
      <MenuItem onClick={callback}>
        {icon}
        <div>{name}</div>
      </MenuItem>
    );
  }

  startEditing() {
    this.setState({
      isEditing: true,
      isOptionsOpened: false,
    });
  }

  showOptions(e) {
    this.setState({
      anchorEl: e.currentTarget,
      isOptionsOpened: true,
    });
  }

  closeOptions() {
    this.setState({
      isOptionsOpened: false,
    });
  }

  async changeSheetName(e) {
    this.props.store.clearLastCreatedSheetId();
    if (this.props.sheet.name === e.target.value) {
      this.setState({
        isEditing: false,
      });
      return;
    }
    this.setState({
      isEditing: false,
      isSaving: true,
    });
    this.isSheetRenamed = true;
    await this.props.renameSheet(e.target.value, this.props.index);
    this.setState({
      isSaving: false,
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (state.isEditing) {
      return null;
    }
    if (props.isEditing) {
      return { isEditing: true };
    }
  }

  // in other packs duplication
  handleDuplicateSheetClick = (e) =>{
    this.setState({
      duplicateSheetPopupOpen:true
    });
  }

  handleDuplicateSheetClose = () => {
    this.setState({ 
      duplicateSheetPopupOpen:false
    });
  }
  
  // in current pack duplication
  handleDuplicateSheetInCurrentPackClick = (e) => {
    this.setState({
      duplicateOptionsPopupOpen: true,
    });
  }

  handleDuplicateOptionsPopupClose = () => {
    this.setState({
      duplicateOptionsPopupOpen: false
    })
  }

  handleDuplicateInCurrentPack = async (e, options=[], dataOptions = {}) => {
    const packId = this.props.store.id;
    const sheetData = this.props.sheet;
    await this.props.duplicateSheet(packId, sheetData, options, dataOptions);
    this.handleDuplicateOptionsPopupClose();
    this.closeOptions();
  }



  render() {
    if (this.state.isEditing && this.props.isSelected) {
      return (
        <input
          key={this.props.index}
          className="activeSheet"
          defaultValue={this.props.sheet.name}
          onChange={(e) => {}}
          onBlur={this.changeSheetName}
          onFocus={(e) => {
            e.target.select();
          }}
          onKeyDown={async (e) => {
            if (e.key === "Enter") {
              this.changeSheetName(e);
            }
            if (e.key === "Escape") {
              this.setState({
                isEditing: false,
              });
            }
          }}
          autoFocus={true}
          // onFocus={(e) => e.target.select()}
          style={{
            borderRadius: 5,
            border: "2px solid " + this.props.themeColor,
            color: COLORS.TEXT_COLOR,
            paddingLeft: 10,
            paddingRight: 10,
            marginLeft: 5,
            minWidth: 250,
            outline: "none",
          }}
        />
      );
    }

    return (
      <>
      <div
        key={this.props.index}
        className={
          this.props.isSelected ? "h-100 activeSheet" : "h-100 inactiveSheet"
        }
        style={{
          fontSize: 14,
          cursor: "pointer",
          display: "flex",
          marginLeft: 5,
          backgroundColor: this.props.isSelected
          ? COLORS.PRIMARY_COLOR
          : "rgba(0, 0, 0, 0.1)",
          borderTopLeftRadius: 2,
          borderTopRightRadius: 2,
          color: this.props.isSelected ? COLORS.SECONDARY_COLOR : "#eee",
          paddingLeft: 15,
          paddingRight: this.props.isSelected ? 18 : 15,
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => {
          if (!this.props.isSelected)
          this.props.changeSheet(this.props.sheet, this.props.index);
        }}
        onDoubleClick={this.startEditing}
        >
        <CustomTooltip
          title={this.props.sheet.name}
          disableHoverListener={
            this.state.isSaving === true ? true : !this.state.overflow
          }
          >
          <SheetName
            ref={(ref) => {
              this.tabRef = ref;
            }}
            >
            {this.props.sheet.name}
          </SheetName>
        </CustomTooltip>
        {this.props.isSelected && this.props.sheet.is_default !== "1" && this.props.sheet.is_log_sheet != 1 && (
          <span onClick={this.showOptions}>
            <MdArrowDropDown
              className="h-100 sheetArrow"
              style={{
                fontSize: 20,
                marginRight: -15,
              }}
              />
          </span>
        )}
          {this.props.sheet.is_log_sheet != 1 &&
        <Menu
          placement="bottom"
          anchorEl={this.state.anchorEl}
          open={this.state.isOptionsOpened}
          onClose={this.closeOptions}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          >
          {this.props.sheet.is_default !== "1" &&
            this.getListItem(
              <MdEdit
              style={styles.icon}
              size={18}
              // color={COLORS.PRIMARY_COLOR}
              />,
              "Rename sheet",
              this.startEditing
              )}
          {/* {this.getListItem(
                      <MdInfo
                        style={styles.icon}
                        size={18}
                        color={COLORS.PRIMARY_COLOR}
                      />,
                      "Edit sheet description",
                      () => {}
                    )}
                    {this.getListItem(
                      <FaLock
                        style={styles.icon}
                        size={18}
                        color={COLORS.PRIMARY_COLOR}
                      />,
                      "Edit sheet permissions",
                      () => {}
                    )}
                    {this.props.sheet.is_default !== "1" &&
                      this.getListItem(
                        <MdContentCopy
                          style={styles.icon}
                          size={18}
                          color={COLORS.PRIMARY_COLOR}
                        />,
                        "Duplicate sheet",
                        () => {}
                      )} */}

          {this.props.sheet.is_default !== "1" &&
            this.getListItem(
              <MdDelete
                style={styles.icon}
                size={18}
                // color={COLORS.PRIMARY_COLOR}
              />,
              "Delete sheet",
              () => {
                this.props.deleteSheet(this.props.sheet, this.props.index);
              }
              )}
            { 
              this.props.sheet.is_default !== "1" && window?.appStore?.getCurrentListContainerStore(this?.props?.sheet?.id)?.permissions?.canChangeSettings() && 
              this.getListItem(
              <MdContentCopy
                style={styles.icon}
                size={18}
                color={COLORS.TEXT_COLOR}
              />,
              "Duplicate sheet in current pack",
              this.handleDuplicateSheetInCurrentPackClick,
            )}

            {
              this.props.sheet.is_default !== "1" && window?.appStore?.getCurrentListContainerStore(this?.props?.sheet?.id)?.permissions?.canChangeSettings() && 
              this.getListItem(
              <MdContentCopy
                style={styles.icon}
                size={18}
                color={COLORS.TEXT_COLOR}
              />,
              "Duplicate sheet in another pack",             
              this.handleDuplicateSheetClick
            )}
            {
                this.getListItem(
                <MdHistory
                    style={styles.icon}
                    size={18}
                  />,
                  "View History",
                  () => {
                    this.props.openLogSheet(this.props.sheet ,this.props.store.id);
                    this.setState({isOptionsOpened : false})
                  }
                )
              }
        </Menu>}
      </div>
        {/* {this.state.duplicateSheetPopupOpen && <DuplicateSheetPacksMenu open={this.state.duplicateSheetPopupOpen} handleClose={this.handleDuplicateSheetClose} data={this.props} 
         />} */}
        {this.state.duplicateSheetPopupOpen && <DuplicateSheet open={this.state.duplicateSheetPopupOpen}
              handleSheetOptionsMenuClose = {this.closeOptions} handleClose={this.handleDuplicateSheetClose} data={this.props} 
         />}
         {/* for current pack we use duplicateOptionsPopupOpen state variable */}
         {
          this.state.duplicateOptionsPopupOpen && <DuplicateSheet open={this.state.duplicateOptionsPopupOpen} 
           handleSheetOptionsMenuClose = {this.closeOptions} handleClose={this.handleDuplicateOptionsPopupClose} data={this.props} 
          currentPack={true} handleDuplicateBtnClicked = {this.handleDuplicateInCurrentPack} />
         }
         </>
    );
  }
}

export default observer(TabName);
const styles = {
  icon: {
    // marginTop: -5,
    marginRight: 5,
  },
};

const SheetName = styled.span`
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 1px 0px;
`;
